module.exports = __webpack_public_path__ + "img/x.ae3caf59.png";